import { useEffect } from 'react'
import { useModal } from '@leroy-merlin-br/backyard-react-ui'

import { LocationForm } from '../../index'

const LocationFormModal = () => {
  const { setModal } = useModal()

  useEffect(() => {
    setModal({
      appElement: 'body',
      hasScroll: false,
      size: 'mega',
      shouldCloseOnOverlayClick: false,
      children: () => <LocationForm showCloseButton={false} />
    })
  }, [setModal])

  return null
}

export default LocationFormModal
